export var EPostInteractions;
(function (EPostInteractions) {
    EPostInteractions["VOTE"] = "@@IPV";
    EPostInteractions["CLAP"] = "@@IPC";
    EPostInteractions["REACT"] = "@@IPR";
})(EPostInteractions || (EPostInteractions = {}));
